export function CollapseAll({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2067 4.39318L8.26671 1.45318C8.23337 1.41984 8.19337 1.38651 8.14671 1.36651C8.10004 1.34651 8.05337 1.33984 8.00004 1.33984C7.94671 1.33984 7.90004 1.35318 7.85337 1.36651C7.80671 1.38651 7.76671 1.41318 7.73337 1.45318L4.79337 4.39318M11.2067 11.6068L8.26671 14.5468C8.23337 14.5801 8.19337 14.6135 8.14671 14.6335C8.10004 14.6535 8.05337 14.6601 8.00004 14.6601C7.94671 14.6601 7.90004 14.6468 7.85338 14.6335C7.80671 14.6135 7.76671 14.5868 7.73337 14.5468L4.79337 11.6068M1.33337 8H14.6667"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
